module.exports = __webpack_public_path__ + "img/ic_level.a39f78c1.svg";